module.exports = __webpack_public_path__ + "static/media/1.03fe6781.jpg";